export default __webpack_public_path__ + "static/media/carousel30.02cd9544.jpg";